if (typeof CartRemoveButton == "undefined") {
  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        // console.log('cart.js click (event)');
        // console.log(event);
        this.closest('cart-items').updateQuantity(this.dataset.index, 0);
      });
    }
  }

  customElements.define('cart-remove-button', CartRemoveButton);
}


if (typeof CartItems == "undefined") {
  class CartItems extends HTMLElement {
    constructor() {
      super();

      // this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

      this.debouncedOnChange = debounce((event) => {
        if (event.target.tagName !== "SELECT") {
          // console.log('cart.js debouncedOnChange');
          // console.log(event);
          this.onChange(event);
        }
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));
    }

    onChange(event) {
      if (event.target.tagName !== "SELECT") {
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
      }
    }

    /*
      ID = the parent id where you want the content to be placed
      SECTION = the name of the section
      SELECTOR = inside the section, the id="" wrapping the innerHTML that you want placed inside ID

      example input:
        id="cart-icon-bubble"
        section/cart-icon-bubble
        selector="cart-icon-bubble-replace"
      example output:
        this will look in section/cart-icon-bubble, take the innerHTML of id="cart-icon-bubble-replace", and insert it into id="cart-icon-bubble"
    */

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: 'main-cart-items',
          selector: '.js-contents-cart-items',
          class: '.main-cart-items',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '#cart-icon-bubble-replace'
        },
        {
          id: 'cart-icon-bubble-utility',
          section: 'cart-icon-bubble-utility',
          selector: '#cart-icon-bubble-utility-replace'
        },
        // {
        //   id: 'cart-live-region-text',
        //   section: 'cart-live-region-text',
        //   selector: '.shopify-section'
        // },
        {
          id: 'main-cart-footer',
          section: 'main-cart-footer',
          selector: '#main-cart-footer-insert',
          class: '.main-cart-footer',
        }
      ];
    }

    updateQuantity(line, quantity, name) {
      this.enableLoading(line);

      // let windowLocationPathname = window.location.pathname == '/cart' ? '/' : '/pages/contact-us';

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: '/pages/contact-us'
      });

      fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          
          /* Send an event to Klaviyo when the cart is emptied */
          if (parsedState.item_count === 0) {
            klaviyo.push(['track', 'Emptied Cart']);
          }

          const cartFooter = document.getElementById('main-cart-footer-insert');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section => {

            if (section.class) {
              // console.log('\n\n\ncart.js1: IF section.class');
              // console.log('cart.js1: section.class: ' + section.class);
              // console.log('cart.js1: section.selector: ' + section.selector);
              // console.log('cart.js1: section.section: ' + section.section);
              // console.log('cart.js1: section.id: ' + section.id);
              document.querySelectorAll(section.class).forEach((item) => {
                const elementToReplace = item;
                elementToReplace.innerHTML =
                  this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              });
            } else {
              // console.log('\n\n\ncart.js2: ELSE section.class');
              // console.log('cart.js2: section.selector: ' + section.selector);
              // console.log('cart.js2: section.section: ' + section.section);
              // console.log('cart.js2: section.id: ' + section.id);
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }

          }));

          if (parsedState.errors) {
            console.log('cart.js parsedState.errors');
            console.log(parsedState.errors);
          }

          // if (parsedState.item_count !== 0) {
          //   this.updateLiveRegions(line, parsedState.item_count);
          // }

          const lineItem =  document.getElementById(`CartItem-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
          this.disableLoading();
          checkFreeGifts();
          updateDiscountCode();

        }).catch((err) => {
          console.warn('cart.js error: ');
          console.warn(err);
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          document.getElementById('cart-errors').textContent = window.cartStrings.error;
          this.disableLoading();
        });
    }

    // updateLiveRegions(line, itemCount) {
    //   if (this.currentItemCount === itemCount) {
    //     console.warn('ERROR cart.js: line');
    //     console.warn(line);
    //     console.warn('ERROR cart.js: this.currentItemCount:');
    //     console.warn(this.currentItemCount);
    //     console.warn('ERROR cart.js: itemCount:');
    //     console.warn(itemCount);
    //     function deleteAllParams() {
    //       const urlObj = new URL(window.location.href);
    //       const urlWithoutQueryParams = `${urlObj.origin}${urlObj.pathname}`;
    //       window.history.replaceState(null, null, urlWithoutQueryParams);
    //     }

    //     setTimeout(() => {
    //       deleteAllParams()
    //       window.location.reload();
    //     }, 500);

    //     // document.getElementById(`Line-item-error-${line}`)
    //     //   .querySelector('.cart-item__error-text')
    //     //   .innerHTML = window.cartStrings.quantityError.replace(
    //     //     '[quantity]',
    //     //     document.getElementById(`Quantity-${line}`).value
    //     //   );
    //   }

    //   this.currentItemCount = itemCount;
    //   this.lineItemStatusElement.setAttribute('aria-hidden', true);

    //   const cartStatus = document.getElementById('cart-live-region-text');
    //   cartStatus.setAttribute('aria-hidden', false);

    //   setTimeout(() => {
    //     cartStatus.setAttribute('aria-hidden', true);
    //   }, 1000);
    // }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      document.getElementById('main-cart-items').classList.add('cart__items--disabled');
      this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
      document.activeElement.blur();
      // this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading() {
      document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
    }
  }

  customElements.define('cart-items', CartItems);

}